export const PRIVACY_POLICY_VERSION = "2026-08-31-pilot-3";
export const TERMS_VERSION = "2026-08-31-pilot-3";
export const EULA_VERSION = "2026-08-31-pilot-3";
export const CONSENT_POLICY_VERSION = "2026-08-31-pilot-1";
export const AGE_OF_MAJORITY = 18;
export const PRIVACY_CONTACT = "contact@ping4all.lu";
export const DPO_NAME = "Ricardo Polar";
export const DPO_ROLE = "Data Protection Officer";
export const DPO_EMAIL = "contact@ping4all.lu";
export const GCP_REGION = "europe-west1";
export const HEALTH_RECORD_HOST = "gcp";
export const EDGE_DEVICE_STORES_PATIENT_RECORDS = false;
export const PING4ALL_LEGAL_NAME = "Ping4All";
export const PING4ALL_ADDRESS =
  "6, Rue de la Fontaine, Esch-sur-Alzette 4122, Luxembourg";

export const CONSENT_PURPOSES = {
  TRAINING_ANALYSIS: "TRAINING_ANALYSIS",
  HEART_RATE: "HEART_RATE",
  CLUB_INTERNAL: "CLUB_INTERNAL",
  IMAGE_PUBLIC_USE: "IMAGE_PUBLIC_USE",
};
